import React, { useState, useEffect } from 'react';
import { Navbar } from './components/landing/Navbar';
import { HeroSection } from './components/landing/HeroSection';
import { TrustBar } from './components/landing/TrustBar';
import { StatsSection } from './components/landing/StatsSection';
import { ArchitectureSection } from './components/landing/ArchitectureSection';
import { EcosystemSection } from './components/landing/EcosystemSection';
import { InnovationsSection } from './components/landing/InnovationsSection';
import { DealLifecycleSection } from './components/landing/DealLifecycleSection';
import { FundPracticeSection } from './components/landing/FundPracticeSection';
import { MandatesSection } from './components/landing/MandatesSection';
import { EngageSection } from './components/landing/EngageSection';
import { Footer } from './components/landing/Footer';
import { BriefingModal } from './components/landing/BriefingModal';

export const FrontierLandingV7 = () => {
  const [briefingOpen, setBriefingOpen] = useState(false);
  const [briefingType, setBriefingType] = useState('');

  const openBriefing = (type) => {
    setBriefingType(type || '');
    setBriefingOpen(true);
  };

  // Reset the document title on the landing page (e.g. after returning from the Company subpage).
  useEffect(() => {
    document.title = 'Frontier Deal OS™ | High-Stakes Strategy & Investment Deals';
  }, []);

  // Scroll to a section when arriving with a hash (e.g. /#deal-aos from the Company page).
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      let tries = 0;
      const tick = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else if (tries++ < 20) {
          setTimeout(tick, 100);
        }
      };
      setTimeout(tick, 100);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-800 font-sans selection:bg-[#F58220]/20 overflow-x-hidden">
      <div className="relative">
        <Navbar onOpenBriefing={openBriefing} />
        <HeroSection onOpenBriefing={openBriefing} />
      </div>
      <TrustBar />
      <StatsSection />
      <div id="deal-aos">
        <ArchitectureSection />
      </div>
      <EcosystemSection />
      <div id="innovations">
        <InnovationsSection />
      </div>
      <div id="lifecycle">
        <DealLifecycleSection />
      </div>
      <div id="practices">
        <FundPracticeSection onOpenBriefing={openBriefing} />
      </div>
      {/* <div id="mandates">
        <MandatesSection />
      </div> */}
      <div id="engage">
        <EngageSection onOpenBriefing={openBriefing} />
      </div>
      <Footer onOpenBriefing={openBriefing} />
      <BriefingModal
        isOpen={briefingOpen}
        onClose={() => setBriefingOpen(false)}
        inquiryType={briefingType}
      />
    </div>
  );
};
